import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { HistoryServiceAckResponse, HistoryServiceModel } from '@gtpl/shared-models/masters';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { PlantIdRequest } from '../unit-codes/dto/plant-id.request';
import { HistoryDTO } from './dto/history.dto';
import { History } from './history-service.entity';

@Injectable()
export class HistoryServiceService {
    constructor(@InjectRepository(History) private repository:  Repository<History>) {
    }

    /**
     * Service to create new history record
     * @param historyDto 
     * @returns 
     */
     async createHistory(historyDto: HistoryDTO): Promise<HistoryServiceAckResponse> {
        const historyEntity = new History();
        historyEntity.category = historyDto.category;
        historyEntity.categoryId = historyDto.categoryId;
        historyEntity.assocRfId = historyDto.assocRfId;
        historyEntity.plantId = historyDto.plantId;
        historyEntity.createdUser = historyDto.createdUser;
        historyEntity.expiryDate = historyDto.expiryDate;
        const historyResponse = await this.repository.save(historyEntity);            
        if (historyResponse) {
            return new HistoryServiceAckResponse(true, 10000, historyDto.category+'History Created Successfully');
        }
    }

    /**
     * Service to get all the history
     * @returns 
     */
    async getHistory(): Promise<HistoryServiceAckResponse> {
        const historyResponse = await this.repository.find({
            order:{historyId: "ASC"},
        });

        const historyDetails: HistoryServiceModel[] = [];
        if (historyResponse.length === 0) {
            throw new ErrorResponse(9999, 'History not found');
        }
        for(const history of historyResponse) {
            const historyModel = new HistoryServiceModel(history.categoryId,history.category,history.plantId,history.assocRfId,history.expiryDate,history.createdAt,history.updatedAt);
            historyDetails.push(historyModel);
        }
        return new HistoryServiceAckResponse(true, 10000, 'History Details Retrived Successfully', historyDetails);       
    }

    /**
     * Service to get all the history by plant id
     * @param plantIdReq
     * @returns 
     */
     async getHistoryByPlantId(plantIdReq: PlantIdRequest): Promise<HistoryServiceAckResponse> {
        const historyResponse = await this.repository.find({
            where: {plantId: plantIdReq.plantId},
            order:{historyId: "ASC"},
        });

        const historyDetails: HistoryServiceModel[] = [];
        if (historyResponse.length === 0) {
            throw new ErrorResponse(9999, 'History not found');
        }
        for(const history of historyResponse) {
            const historyModel = new HistoryServiceModel(history.categoryId,history.category,history.plantId,history.assocRfId,history.expiryDate,history.createdAt,history.updatedAt);
            historyDetails.push(historyModel);
        }
        return new HistoryServiceAckResponse(true, 10000, 'History Details Retrived Successfully', historyDetails);       
    }
}
